<template>
  <div class="today-call">
    <FilterHeader
      @search="search"
      @refresh="refresh"
      :searchPlaceholder="$t('callPopScreen.clientPhoneSearch')"
    >
      <div class="call-pop-screen-filter-options">
        <div
          :class="['filter-option', { active: filterIndex === 0 }]"
          @click="changeFilter(0)"
        >{{ $t('callPopScreen.byContactTimeAsc') }}</div>
        <div
          :class="['filter-option', { active: filterIndex === 1 }]"
          @click="changeFilter(1)"
        >{{ $t('callPopScreen.byContactTimeDesc') }}</div>
      </div>
    </FilterHeader>
    <div class="group-tabs">
      <div
        :class="['group-tabs-item', { active: reqParam.status === 2 }]"
        @click="changeGroup(2)"
      :title="$t('callPopScreen.pending')"
      >{{ $t('callPopScreen.pending') }}</div>
      <div
        :class="['group-tabs-item', { active: reqParam.status === 0 }]"
        @click="changeGroup(0)"
        :title="$t('callPopScreen.unprocessed')"
      >{{ $t('callPopScreen.unprocessed') }}</div>
      <div
        :class="['group-tabs-item', { active: reqParam.status === 1 }]"
        @click="changeGroup(1)"
        :title="$t('callPopScreen.processed')"
      >{{ $t('callPopScreen.processed') }}</div>
      <div
        :class="['group-tabs-item', { active: reqParam.status === 3 }]"
        @click="changeGroup(3)"
        :title="$t('callPopScreen.cancelled')"
      >{{ $t('callPopScreen.cancelled') }}</div>
    </div>
    <div class="call-list">
      <template v-if="isFinished && callList.length === 0">
        <div class="view-more">
          <div class="view-more-btn">{{ $t('callPopScreen.noRecords') }}</div>
        </div>
      </template>
      <template v-else>
        <CallInfoItem
          v-for="(item) in callList"
          :key="item.id"
          :item="item"
          :fieldMap="{
            clePhone: 'phone',
            cleName: 'clientName',
            cleId: 'extId',
            time: 'nextTime'
          }"
          listType="laterContact"
          @changegroup="changeGroup"
        />
        <div class="view-more">
          <div v-if="!isFinished" class="view-more-btn" @click="loadMore">{{isLoading ? $t('common.loading') : $t('callPopScreen.viewMore')}}</div>
          <div v-else class="view-more-btn">{{ $t('callPopScreen.noMore') }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getContactLists } from "@/api/ektv3";
import { mapGetters } from 'vuex';
import CallInfoItem from '../callInfoItem/index'
import FilterHeader from '../filterHeader'
import dayjs from 'dayjs';
import { getShortId } from '@/utils'
export default {
  props: {

  },
  data() {
    return {
      callList: [],
      isFinished: false,
      isLoading: false,
      reqParam: {},
      filterIndex: 0,
      reqId: ''
    }
  },
  components: {
    CallInfoItem,
    FilterHeader
  },
  inject: ['curCall', 'setCurCall'],
  computed: {
    ...mapGetters(["userInfo"]),
    newCurCall() {
      return this.curCall()
    },
  },
  watch: {
    callList(arr) {
      const index = arr.findIndex(v => v.id === this.newCurCall.id)
      if(index !== -1) {
        const item = arr[index]
        this.setCurCall({
          itemType: this.newCurCall.itemType,
          id: item.id,
          cle_id: item.extId,
          cle_name: item.clientName,
          cle_phone: item.phone,
          call_id: item.call_id,
          call_type: item.call_type
        })
      }
    }
  },
  created() {
    this.reqParam = {
      solve_user_id: this.userInfo.userId,
      type: 1,
      current_page: 1,
      per_page: 20,
      status: 2,
      sort: 'next_time',
      order: 'asc'
    }
    this.reqId = getShortId()
    this.getCdrList(false, this.reqId)
    // 监听更新客户
    // this._Bus.$on("updClient", this.updClient);
  },
  beforeDestroy() {
    // this._Bus.$off("updClient", this.updClient)
  },
  methods: {
    getCdrList(isRefresh, reqId) {
      if(isRefresh) {
        this.isFinished = false
        this.reqParam.page = 0
        this.reqParam.rows = 20
        this.reqParam.size = 20
        this.callList = []
      }
      if(this.isFinished) return
      this.isLoading = true
      const { my: { ektv3_page }, } = this._config.URL;
      getContactLists(ektv3_page, { ...this.reqParam, page: this.reqParam.page + 1 }).then(res => {
        if(res.code === 0 && this.reqId === reqId) {
          this.reqParam.page++
          this.callList = [...this.callList, ...res.data.data]
          if(res.data.data.length < 20) {
            this.isFinished = true
          }
        }
      }).finally(() => {
        if(this.reqId === reqId) {
          this.isLoading = false
        }
      })
    },
    search(val) {
      this.reqParam.phone = val
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    refresh() {
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    changeFilter(val) {
      this.filterIndex = val
      if(val === 0) {
        this.reqParam.sort = 'next_time'
        this.reqParam.order = 'asc'
      } else {
        this.reqParam.sort = 'next_time'
        this.reqParam.order = 'desc'
      }
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    changeGroup(val) {
      this.reqParam.status = val
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    loadMore() {
      this.reqId = getShortId()
      this.getCdrList(false, this.reqId)
    },
    onSwitchClient(item) {
      const index = this.callList.findIndex((v) => v.id === item.id)
      if(index !== -1) {
        const newItem = { ...this.callList[index], ...item }
        this.callList.splice(index, 1, newItem)
      }
    },
    updClient(clientInfo) {
      const item = {
        id: clientInfo.id,
        extId: clientInfo.cle_id,
        clientName: clientInfo.cle_name,
        phone: clientInfo.cle_phone
      }
      this.onSwitchClient(item)
    },
  }
}
</script>

<style lang="less" scoped>
.today-call {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .group-tabs {
    display: flex;
    align-items: center;
    height: 24px;
    margin-bottom: 8px;
    padding: 0 12px;
    gap: 8px;
    &-item {
      flex: 1;
      display: inline-block;
      line-height: 24px;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      height: 100%;
      padding: 0 8px;
      background: #F2F3F5;
      border-radius: 6px;
      color: #323233;
      font-size: 12px;
      user-select: none;
      cursor: pointer;
      &.active {
        color: #0090ff;
        font-size: 12px;
        font-weight: 600;
        background: #E6F8FF;
      }
    }
  }
  .call-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    .view-more {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 40px;
      color: #969799;
      font-size: 14px;
      &-btn {
        display: flex;
        align-items: center;
        height: 100%;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/laterContact/index.vue